<div class="home {{sezione}}" >
    <div class="mygw">
       <a [routerLink]="['/macchine']" class="nowrap"><span>{{'Macchine'|translate}}</span></a>
    </div>
    <div class="blocco ricambi">
        <a [routerLink]="['/ricambi']" class="nowrap"><span>{{'Ricambi'|translate}}</span></a>
    </div>
    <div class="blocco accessori">
        <a [routerLink]="['/accessori']" class="nowrap"><span>{{'Accessori'|translate}}</span></a>
    </div>
    <div class="blocco documentazione">
        <a [routerLink]="['/documentazione']" class="nowrap"><span>{{'Documentazione'|translate}}</span></a>
    </div>
    <div class="blocco garanzie">
        <a [routerLink]="['/matricole']" class="nowrap"><span>{{'Garanzie'|translate}}</span></a>
    </div>
    <div class="blocco bacheca">
        <a [routerLink]="['/bacheca']" class="nowrap"><span>{{'Bacheca'|translate}}</span></a>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/tws-home/tws-home.component.html